import { useEffect, useState } from "react";
import { ambience, playDecisionSfx, loadSoundPref, saveSoundPref, loadNarratePref, saveNarratePref } from "@/lib/audio";

// Owns the sound preferences plus the ambience/SFX lifecycle for a case run.
export function useCaseAudio(phase, scenario, current) {
  const [soundOn, setSoundOn] = useState(loadSoundPref());
  const [autoNarrate, setAutoNarrate] = useState(loadNarratePref());

  useEffect(() => {
    if (phase === "playing" && soundOn && scenario) {
      ambience.start(scenario.modality, scenario.id);
    } else {
      ambience.stop();
    }
    return () => ambience.stop();
  }, [phase, soundOn, scenario]);

  useEffect(() => {
    if (phase === "playing" && soundOn && scenario) {
      playDecisionSfx(scenario.decisions[current]?.id);
    }
  }, [phase, soundOn, scenario, current]);

  const toggleSound = () =>
    setSoundOn((v) => {
      saveSoundPref(!v);
      return !v;
    });

  const toggleNarrate = () =>
    setAutoNarrate((v) => {
      saveNarratePref(!v);
      return !v;
    });

  return { soundOn, autoNarrate, toggleSound, toggleNarrate };
}
